import React, { useState } from "react";
import HeroLayout from "../components/HeroLayout";
import { Link } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import PhoneNumberField from "../components/PhoneNumberField";
const images = require.context("../assets/images", false);

function GoldenTriangleShortTour() {

     const [formData, setFormData] = useState({
      name: "",
      email: "",
      countryCode: "+91",
      phone: "",
      message: "",
      tour: "Golden Triangle Short Tour"
    });
    const [captchaToken, setCaptchaToken] = useState(null);  
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState("");
  
    // Handle Input Change
    const handleChange = (e) => {
      setFormData({
        ...formData,
        [e.target.name]: e.target.value
      });
  
      setErrors({
        ...errors,
        [e.target.name]: ""
      });
    };
  
    // Validation Function
    const validate = () => {
      let newErrors = {};
  
      if (!formData.name.trim()) {
        newErrors.name = "Name is required";
      }
  
      if (!formData.email.trim()) {
        newErrors.email = "Email is required";
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
        newErrors.email = "Invalid email format";
      }
  



      if (!formData.phone.trim()) {
    newErrors.phone = "Phone number is required";
  } else if (!/^[0-9]{7,15}$/.test(formData.phone)) {
    newErrors.phone = "Enter valid phone number";
  }
  
      if (!formData.message.trim()) {
        newErrors.message = "Message is required";
      }
  
      return newErrors;
    };
  
    // Submit Form
    const handleSubmit = async (e) => {
      e.preventDefault();
  
      const validationErrors = validate();
  
      if (Object.keys(validationErrors).length > 0) {
        setErrors(validationErrors);
        return;
      }
  
      try {
        if (!captchaToken) {
  setErrors({ captcha: "Please verify captcha" });
  return;
}
        setLoading(true);
  
        const response = await fetch("https://www.luxurygoldentriangle.com/bkadmn/wp-json/custom/v1/contact_tour", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            ...formData,
            phone: `${formData.countryCode} ${formData.phone}`.trim(),
            captcha: captchaToken
          })
        });
  
        const data = await response.json();
  
        if (data.success) {
          setSuccess("Message sent successfully!");
          setErrors({ captcha: "" });
          setFormData({
            name: "",
            email: "",
            countryCode: "+91",
            phone: "",
            message: "",
            tour: "Golden Triangle Short Tour"
          });
        } else {
          setSuccess(data.message || "Something went wrong.");
        }
  
      } catch (error) {
        setSuccess("Server error. Please try again.");
      } finally {
        setLoading(false);
      }
    };
  

  return (
    <>
    <HeroLayout>
      <div className="banner-bg  bg-top bgbottom" style={{
            backgroundImage:
            `linear-gradient(#370b2e66, #370b2e66), url(${images("./ShortTour.webp")})`
        }}
        >
        <div className="container">
            <div className="inner-banner-content full-width center color-white mt-5">
            <h1>Golden Triangle - Short Tour​</h1>
            </div>
        </div>
        </div>

    </HeroLayout>
   <div className="tour-details mt-80">
  <div className="container">
        <div className="mb-5">
      <div className="tour-highlight-summary standard-highlight-layout">
        <div className="tour-highlights-card">
          <h2>Tour Highlights</h2>
          <ul>
            <li><span aria-hidden="true">{"\u2605"}</span>Witness the Taj Mahal in the Golden Hour of Sunrise</li>
            <li><span aria-hidden="true">{"\u2605"}</span>Explore 8 Magnificent UNESCO World Heritage Sites</li>
            <li><span aria-hidden="true">{"\u2605"}</span>Curated Stays at India's Finest Luxury Hotels</li>
            <li><span aria-hidden="true">{"\u2605"}</span>Expert, English-Speaking Private Guide Throughout</li>
			<li><span aria-hidden="true">{"\u2605"}</span>Exclusive Private Car & Driver at Your Disposal</li>
			<li><span aria-hidden="true">{"\u2605"}</span>Round-the-Clock Personalised Assistance</li>
          </ul>
        </div>
       <div className="tour-highlights-cardbkgrey">
		<h2>Tour Details</h2>
		<p><b>Cities</b>: Delhi &bull; Agra &bull; Jaipur</p>
          <p><b>Duration</b>: 3 Nights / 4 Days</p>
          <p><b>Best Time to Visit</b>: September &ndash; March</p>
          <p><b>Tour Type</b>: Private & Luxury</p>
          <p><b>Customizable</b>: Yes — Tailored to Your Preferences</p>
          <p><b>Ideal For</b>: Couples & Business Travelers</p>
         <p><b>Language</b>: English, Hindi, Spanish, German, Italian, French, Japanese, Chinese</p>
		  

        </div>
      </div>
    </div>
	<h2 className="mb-4">Itinerary</h2>
    <div className="tour-details-card mb-4">
      <div className="row align-items-center">
        <div className="col-md-4">
          <div className="tour-details-card-img">
            <img src={images("./Delhi2.jpeg")} />
            <span>Day 1</span>
          </div>
        </div>
        <div className="col-md-8">
          <div className="border-bottom-card">
            <h3>Arrive in Delhi</h3>
            <p className="mb-3 font-14">
            Welcome to incredible India! After you land, meet and greet by our representative at the airport, and transfer to your hotel. After some rest, we will start the Delhi sightseeing and visit the tallest brick minaret in the world – the <b>Qutub Minar</b> before driving past the <b>India Gate</b>, the Secretariat and the Presidential House. Evening will be at leisure.            </p>
<ul className="mb-3">
              <li>Qutub Minar</li>
              <li>India Gate</li>
            </ul>
            <p className="colr-prim mb-3">Meals: NA</p>
          </div>
        </div>
      </div>
    </div>
    <div className="tour-details-card mb-4">
      <div className="row align-items-center">
        <div className="col-md-4">
          <div className="tour-details-card-img">
            <img src={images("./Delhi3.jpeg")} />
            <span>Day 2</span>
          </div>
        </div>
        <div className="col-md-8">
          <div className="border-bottom-card">
            <h3>Delhi – Agra<span>(4 - 5 hours)</span></h3>
            <p className="mb-3 font-14">
The ancient capital of India is a kaleidoscope of cultural experiences. After breakfast, our adventure begins in <b>Old Delhi</b>, the food capital of the country! Hop on a rickshaw and check out the winding lanes that present hundreds of years of rich history. Savour delectable cuisine before visiting the stunning <b>Humayun Tomb</b> and <b>Bangla Sahib</b>. After lunch, our driver will drive you to the city of Agra – the home of the Taj Mahal. Overnight stay in Agra.
            </p>
            <ul className="mb-3">
              <li>Old Delhi</li>
              <li>Humayun Tomb</li>
              <li>Bangla Sahib</li>
            </ul>

            <p className="colr-prim mb-3">Meals: Breakfast</p>
          </div>
        </div>
      </div>
    </div>
    <div className="tour-details-card mb-4">
      <div className="row align-items-center">
        <div className="col-md-4">
          <div className="tour-details-card-img">
            <img src={images("./frg.webp")} />
            <span>Day 3</span>
          </div>
        </div>
        <div className="col-md-8">
          <div className="border-bottom-card">
            <h3>Agra - Jaipur</h3>
            <p className="mb-3 font-14">
Sunrise visit to the <b>Taj Mahal</b> (the seventh wonder of world, built by Shah Jahan as a memorial to his wife Mumtaz Mahal), followed by breakfast at hotel and later visit the <b>Agra Fort</b> – a stunning reminiscent of a bygone era. After visit, we will drive to Jaipur.
<br />
Jaipur is also called the pink city – a UNESCO World Heritage city. On arrival, check-in your hotel. In the evening, you may enjoy Rajasthani food with dance show by local artists (on direct payment basis). Overnight stay in hotel.            </p>
            <ul className="mb-3">
              <li>Taj Mahal</li>
              <li>Agra Fort</li>
            </ul>
            <p className="colr-prim mb-3">Meals: Breakfast</p>
          </div>
        </div>
      </div>
    </div>
    <div className="tour-details-card mb-4">
      <div className="row align-items-center">
        <div className="col-md-4">
          <div className="tour-details-card-img">
            <img src={images("./re.webp")} />
            <span>Day 4</span>
          </div>
        </div>
        <div className="col-md-8">
          <div className="border-bottom-card">
            <h3>Jaipur - Delhi</h3>
            <p className="mb-3 font-14">
              Enjoy your breakfast and go on an epic journey through time! Jaipur is full of mesmerizing forts and gorgeous palaces that once served as the residence of India’s finest. <br /> 
Witness the sheer majesty of the <b>Amer Fort</b> and the <b>City Palace</b> before visiting the <b>Jantar Mantar</b> – an ancient observatory, and the Hawa Mahal. You may visit the local markets of Jaipur for some souvenirs. <br />
After visit, we will driver back to Delhi and our driver will drop you at Delhi airport for your onward flight.
            </p>
            <ul className="mb-3">
              <li>Amer Fort</li>
              <li>City Palace</li>
              <li>Jantar Mantar</li>
            </ul>
            <p className="colr-prim mb-3">Meals: Breakfast</p>
          </div>
        </div>
      </div>
    </div>
    <div className="row tour-summary-row">
      <div className="col-md-12 col-lg-6">
        <div className="tour-details-card tour-summary-left-card mb-4 py-5 px-4">
          <h2 className="mb-3">Inclusions</h2>
    
          <ul className="tick-list">
            <li>Accommodation in selected or similar hotels on double/twin sharing </li>
            <li>Daily buffet breakfast except on Day 1</li>
            <li>
            Air conditioned Toyota Crysta with driver for intercity transfers and sightseeing as per itinerary             </li>
            <li>Airport pick-up and drop as per itinerary</li>
            <li>Monument entrance fee</li>
            <li>English speaking city guides</li>
            <li>Complimentary amenities: Mineral Water & Snack Basket</li>
            <li>All taxes included</li>
            <li>24x7 assistance throughout the tour </li>            
          </ul>
        </div>
      </div>
      <div className="col-md-12 col-lg-6">
        <div className="tour-details-card mb-4 py-5 px-4">
          <h2 className="mb-3">Exclusions</h2>
          <ul className="dot-list-card">
            <li>International or domestic airfare (booking available on request)</li>
            <li>Visa</li>
            <li>Travel Insurance</li>
            <li>Early check in and late check out is per hotel dicretion</li>
            <li>Any expense of personal nature like laundry, mini bar, telephone, room service etc.</li>
            <li>Any tour or activity not mentioned above</li>
            <li>Anything not specified in 'Inclusions' column above</li>            
          </ul>
        </div>
        <div className="tour-details-card mb-4 py-5 px-4">
          <h2 className="mb-3">Hotels &amp; Car</h2>
          <p>
            We recommend and use 5 star hotels which may be a standard 5 star
            hotel, a luxury 5 star hotel or a heritage one. Similarly in cars,
            we use Toyota Innova Crysta as standard and upgrades are available
            on request. You can check list of recommended{" "}
            <Link to="/5-star-luxury-hotels">Luxury Hotels here</Link> and list of available{" "}
            <Link to="/car-details">cars/vehicles here</Link>.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
<div className="tour-form mt-80" id="enquire">
  <img className="top-left-position" src={images("./dance-man.svg")} />
  <img className="bottom-right-position" src={images("./peacock.svg")} />
  <div className="container">
    <div className="form-card">
      <div className="heading center">
        <h2>Enquire Now</h2>
        <p>
          Share your details and concerns with us, and our expert team will get
          in touch at your convenience.
        </p>
      </div>
           <form onSubmit={handleSubmit} noValidate>
             <div className="row">
               <div className="col-md-12 col-lg-6">
                 <div className="form-input-group mb-4">
                   <label htmlFor="name">
                     Name<span>*</span>
                   </label>
                   <input
                     type="text"
                     className="form-control"
                     placeholder="Enter your name"
                     name="name"
                     value={formData.name}
                     onChange={handleChange}
                   />
                   {errors.name && <p className="error">{errors.name}</p>}
                 </div>
               </div>
               <div className="col-md-12 col-lg-6">
                 <div className="form-input-group mb-4">
                   <label htmlFor="name">
                     Email<span>*</span>
                   </label>
                   <input
                     type="email"
                     className="form-control"
                     placeholder="Enter your email"
                     name="email"
                     value={formData.email}
                     onChange={handleChange}
                   />
                   {errors.email && <p className="error">{errors.email}</p>}
                 </div>
               </div>
               <div className="col-md-12 col-lg-6">
                 <PhoneNumberField
                   countryCode={formData.countryCode}
                   value={formData.phone}
                   onChange={handleChange}
                   error={errors.phone}
                 />
               </div>
               <div className="col-md-12 col-lg-6 messagefield">
                 <div className="form-input-group mb-2">
                   <label htmlFor="name">
                     Message<span>*</span>
                   </label>
                   <textarea
                     name="message"
                     className="form-control"
                     placeholder="Please share your travel details, including destination, travel dates, number of travelers, hotel preferences, budget, and any special requirements."
                     value={formData.message}
                     onChange={handleChange}
                   />
                   {errors.message && <p className="error">{errors.message}</p>}
                 </div>
               </div>
                              <div className="col-md-12">
                <ReCAPTCHA
                  sitekey="6Ld4kHosAAAAAKsayfQ1saymv6SeauUSxkHSn55b"
                  onChange={(token) => setCaptchaToken(token)}
                />
                {errors.captcha && <p className="error">{errors.captcha}</p>}
                </div>
             </div>
             <div className="form-btn center mt-3">
     
                   <button type="submit" disabled={loading} className="primary-btn">
                     {loading ? "Sending..." : "Submit"} <img src={images("./arrow-right-btn.svg")} alt="Arrow" />
                   </button>
                      {success && <p className="success">{success}</p>}
               <p className="center mt-2">
                 Not your preferred tour? Click here for a{" "}
                 <Link to="/luxury-golden-triangle-enquiry" className="tailor-link">
                   <img src={images("./11.png")} />
                   Tailor Made Tour
                 </Link>
                 .
               </p>
             </div>
           </form>
    </div>
  </div>
</div>

    </>
  );
}

export default GoldenTriangleShortTour;
